<!-- Todo, when we switch to Vue 3 we can get rid of the 'contents' display property and use fragements! -->
<template>
  <div class="sticky backface-hidden" :class="computedClasses.wrapper">
    <CTopbar :topbar="headerSettings.topbar" :class="computedClasses.topbar" />
    <CHeader
      @open-side-panel="sidePanelOpen = true"
      :header="headerSettings"
      :class="computedClasses.header"
    />
  </div>
</template>

<script>
import CHeader from './CHeader';
import CTopbar from './CTopbar';

export default {
  props: ['headerSettings'],
  data: () => ({
    sidePanelOpen: false,
    scrolled: false,
  }),
  components: {
    CHeader,
    CTopbar,
  },
  methods: {
    handleScroll({detail: scrollTop}) {
      if (scrollTop > 10) {
        this.scrolled = true;
      } else {
        this.scrolled = false;
      }
    },
  },
  computed: {
    computedClasses() {
      const headerSettings = this.headerSettings;
      const {
        topbar: {sticky: topbarSticky},
      } = headerSettings;
      const {sticky} = headerSettings;

      let wrapper = '';
      let topbar = '';
      let header = '';

      if (sticky && topbarSticky) {
        wrapper += 'sticky';
      } else {
        wrapper += 'display-contents';
      }

      if (!sticky && topbarSticky) {
        topbar += 'sticky';
      }

      if (sticky && !topbarSticky) {
        header += 'sticky';
      }

      if (this.scrolled) {
        header += ' scrolled';
      }

      return {
        wrapper,
        topbar,
        header,
      };
    },
  },
  mounted() {
    window.addEventListener('debouncedScroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('debouncedScroll', this.handleScroll);
  },
};
</script>

<style>
.sticky {
  top: 0px;
  position: sticky;
  z-index: 10;
}

.display-contents {
  display: contents;
}

.backface-hidden {
  backface-visibility: hidden;
}
</style>
